import React from 'react';
import './Styles.scss';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button, Form, Input, Dropdown} from "semantic-ui-react";
import TxtAreaLbl from "../../../../components/Input/TextArea/TextAreaLbl";
import {Checkbox} from 'antd';
import Lbl from "../../../../components/Label/Lbl";
import * as common from "../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import axios_eventtag from "../../../../axios/axios_eventtag";
import apiConfig from "../../../../axios/axios_api_services";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import IntlTelInput from "react-intl-tel-input";
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";
import * as util from "../../../../util/Validator";
import * as EmailValidator from "email-validator";
import axios_tags from "../../../../axios/axios_tag";

// function disabledDate(current) {
//   return current && current < moment().startOf("day");
// }

class App extends React.Component {

  state = {

    notificationTitle: "",
    notificationText: "",
    notificationMail: false,
    notificationApp: false,
    notificationSms: false,
    name: "",
    description: "",
    message_text_count: 500,

    searchType:'NIC',
    searchMobile:'',
    userSearch:'',
    validSearchMobile:false,
    userDetail:null,
    searchMode:false,
    userId:''
  };

  onHandleChangeNotificationCheckBox = (item) => {
    switch (item) {
      case "EMAIL":
        this.setState({notificationMail: !this.state.notificationMail});
        break;
      case "APP":
        this.setState({notificationApp: !this.state.notificationApp});
        break;
      case "SMS":
        this.setState({notificationSms: !this.state.notificationSms});
        break;
      default:
        break;
    }

  };

  onChangeAction = (event) =>{

    if(event.target.name === 'userSearch' && this.state.searchType === 'Vehicle Number') {
      this.setState({
        userSearch : event.target.value.toString().toUpperCase()
      })
    } else {
      this.setState({
        [event.target.name]: event.target.value
      })
    }

  }

  validateNotification = () => {
    this.state.userId === '' ? common.notifyMessage("Please select a user") : this.validateNotification_();
  };


  validateNotification_ = () => {
    this.state.name === "" ?
      common.notifyMessage("Please enter notification title") :
        this.state.description === "" ?
          common.notifyMessage("Please enter notification text") :
          !this.state.notificationMail && !this.state.notificationApp && !this.state.notificationSms ?
            common.notifyMessage("Please select notification media") : this.sendToBackEnd();
  }

  sendToBackEnd = () => {
    const {userId, name, description, notificationMail, notificationApp, notificationSms} = this.state ;
    const obj = {
      "notification_title" : name,
      "notification_text" :description,
      "notification_mail" : notificationMail,
      "notification_app" : notificationApp,
      "notification_sms" : notificationSms,
    }

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_eventtag.put(apiConfig.SEND_SINGLE_NOTIFICATION({corporateId: corporateId, userId: userId}), obj, {headers: headers})
    .then(response => {
      if (response.data.success) {
        common.warningAlert("Notification sent successfully!", 0);
      }
      else {
        common.warningAlert(response.data.message, 1)
      }
      this.clearFeilds()
    })
    .catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.sendToBackEnd()
      }
    })
    .finally(fin => {
      this.props.spinnerHandler(false);
    });
  };

  clearFeilds = () => {
    this.setState ({
      name: "",
      description: "",
      notificationMail: false,
      notificationApp: false,
      notificationSms: false,
      message_text_count: 500,
      searchType:'NIC',
      searchMobile:'',
      userSearch:'',
      validSearchMobile:false,
      userDetail:null,
      searchMode:false,
      userId:''
    })
  };

  onHandleChangeHostMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);
    this.setState({
      validSearchMobile:condition,
      searchMobile:value,
      userSearch: withdialcod.substr(1).replace(/\s/g, "")
    });
  };

  searchUserUsingIdentity = () => {
    let identity = this.state.userSearch.trim();
    let isValidIdentity = false;
    if(this.state.searchType === "NIC") {
      isValidIdentity = util.identityValueValidator(identity, this.state.searchType);
    } else if (this.state.searchType === "Mobile") {
      this.state.validSearchMobile ? isValidIdentity = true : common.notifyMessage("Please add a valid mobile number.");
    } else if (this.state.searchType === "Email") {
      EmailValidator.validate(identity) ? isValidIdentity = true : common.notifyMessage("Please add a valid email.");
    } else if(this.state.searchType === "Vehicle Number") {
      isValidIdentity = util.vehicleNumberPlateValidation(identity) ? true : common.notifyMessage("Please add a valid vehicle number.");
    }else{
      isValidIdentity = true;
    }

    if (isValidIdentity) {
      this.props.spinnerHandler(true);
      const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};

      let corporateId = this.props.usr_obj.corporates[0].corporateId;

      axios_tags.get(apiConfig.CORPORATE_VISITOR_IDENTIFY_UPDATED_SEARCH({
        corporateId:corporateId,
        identifyValue:identity,
        searchType: this.state.searchType === "Mobile" ? 'mobile' :
          this.state.searchType === "Email" ? 'email' :
            this.state.searchType === "Vehicle Number" ? 'vehicleNo': 'identificationValue'
      }), { headers: headers })
        .then(response => {
          if (response.data.success) {
            let res = response.data.visitor;
            if(res !== undefined){
              const temp = {
                name: `${res.firstName !== null ? res.firstName : ''} ${res.lastName !== null ? res.lastName : ''}` ,
                email: `${res.email !== null ? res.email : '-'}`,
                mobile: `${res.mobile !== null ? res.mobile : ''}`,
                identificationValue: `${res.identificationValue !== null ? res.identificationValue : ''}`
              }
              this.setState({ userDetail: temp, searchMode:true, userId: res.userId})
            }else {
              this.setState({ userDetail: null, searchMode:true, userId: '' })
            }
          } else {
            this.setState({ userDetail: null, searchMode:true, userId: '' })
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          this.setState({ userDetail: null, searchMode:true })
          if (result === 1) {
            // this.searchAttendeeUsingIdentity()
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
    }

  };

  render() {

    const {searchType, searchMobile, userSearch, userDetail, name, description, notificationMail, searchMode,
      notificationApp, notificationSms} = this.state

    return (
      <div className={"set-notification-admin-single"}>
        <Row>
          <Col xs="12" lg={"6"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Filter User
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg={10}>
                      <div>
                        <Form>
                          <Form.Group widths='equal'>
                            {
                              searchType === 'Mobile' ?
                                <div className={"display-inline"} id="mobile-input">
                                  <IntlTelInput
                                    style={{width: '100%'}}
                                    type={"text"}
                                    fieldName={"Mobile Number"}
                                    value={searchMobile}
                                    containerClassName="intl-tel-input dashboard-intl"
                                    inputClassName="form-control"
                                    onPhoneNumberChange={this.onHandleChangeHostMobile}
                                    required={true}
                                    preferredCountries={['lk']}
                                    defaultCountry={"lk"}
                                    nationalMode={false}
                                    icon='mobile alternate'
                                  />
                                  <Dropdown
                                    style={{borderTopLeftRadius:0, borderBottomLeftRadius:0, display:'flex'}}
                                    button basic floating
                                    value={searchType}
                                    options={DropDownConst.IdentificationsHostAdvanced}
                                    onChange={
                                      (e, {value}) => {
                                        this.setState({
                                          searchType: value, userSearch:"", userDetail: null, searchMode:false
                                        })
                                      }
                                    }
                                  />
                                </div> :
                                <Input
                                  style={{width: '100%', paddingRight:'15px'}}
                                  className="xx"
                                  action={
                                    <Dropdown
                                      button basic floating
                                      value={searchType}
                                      options={DropDownConst.IdentificationsHostAdvanced}
                                      onChange={
                                        (e, {value}) => {
                                          this.setState({
                                            searchType: value, userSearch:"", userDetail: null, searchMode:false
                                          })
                                        }
                                      }
                                    />
                                  }
                                  name='userSearch'
                                  icon='search'
                                  iconPosition='left'
                                  placeholder='Search Here'
                                  value={userSearch}
                                  onChange={this.onChangeAction}
                                />
                            }
                          </Form.Group>
                        </Form>
                      </div>
                    </Col>
                    <Col lg={"2"} md={"2"} sm={"2"} xs={"2"} className="btn-holder" style={{paddingLeft:'9px'}}>
                      <Button className="btn-style" style={{color: 'white'}} onClick={this.searchUserUsingIdentity}>Search</Button>
                    </Col>
                  </Row>
                  {
                      userDetail !== null && <>
                        <Row>
                          <Col lg={6}>
                            <Lbl>Full Name</Lbl>
                            <p>{userDetail.name}</p>
                          </Col>
                          <Col lg={6}>
                            <Lbl>Email</Lbl>
                            <p>{userDetail.email}</p>
                          </Col>
                        </Row>
                        <Row className={'mt-1'}>
                          <Col lg={6}>
                            <Lbl>Mobile No.</Lbl>
                            <p>{userDetail.mobile}</p>
                          </Col>
                          <Col lg={6}>
                            <Lbl>Identification Value</Lbl>
                            <p>{userDetail.identificationValue}</p>
                          </Col>
                        </Row>
                      </>
                  }
                  {
                    userDetail === null && searchMode && <p>User details not Found.</p>
                  }
                </CardBody>
              </Collapse>
            </Card>
          </Col>
          <Col xs="12" lg={"6"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Create Notifications
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    {/*<Col lg ={2}></Col>*/}
                    <Col lg={12}>
                      <Row>
                        <Col lg={12}>
                          <Form>
                            <Form.Group widths='equal'>
                              <TxtLbl
                                required
                                tagText={"Notification Title"}
                                placeholder={"Enter notification title"}
                                value={name}
                                name='name'
                                onChange={this.onChangeAction}
                              />
                            </Form.Group>
                            <Form.Group widths='equal'>
                              <TxtAreaLbl
                                required
                                maxLength={500}
                                tagText={"Notification Text"}
                                placeholder={"Enter notification text"}
                                value={description}
                                name='description'
                                onChange={this.onChangeAction}
                              />
                            </Form.Group>
                            <div className={'text-right'}><span>{500 - (description.length)}</span><span>/ 500</span></div>
                          </Form>
                        </Col>
                        <Col lg={6} md={6}>
                          <Lbl required>Notification Media</Lbl>
                          <Row className={""}>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={notificationMail}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("EMAIL")}
                              >
                                E-mail
                              </Checkbox>
                            </Col>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={notificationApp}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("APP")}
                              >
                                Mobile App
                              </Checkbox>
                            </Col>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={notificationSms}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("SMS")}
                              >
                                SMS
                              </Checkbox>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={12} md={12} className={"text-center"}>
                          <Button
                            className="btn-style"
                            style={{color: 'white'}}
                            onClick={this.validateNotification}
                          >Send</Button>
                        </Col>
                      </Row>
                    </Col>
                    {/*<Col lg ={2}></Col>*/}
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  test_alleventobject: state.eventReducer.allEventsObj,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
